export default __webpack_public_path__ + "static/media/My-students.c6223b71.svg";